<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="history !== null && history.length > 0">
      <chat-message
        v-for="messageCont in history"
        :key="messageCont.message.id"
        :messageCont="messageCont"
      />
    </template>

 </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import ChatMessage from './chat/Message.vue';

export default {
  name: 'ClubChat',

  components: {
    LoadingIndicator,
    ChatMessage,
  },

  props: {
    clubId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      history: null,
    };
  },

  computed: {
    message() {
      if(this.history !== null && this.history.length === 0) {
        return 'No messages.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/club/${this.clubId}/history`;
    HTTP.get(url)
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.history = data;
    })
    .catch(e => {
      notifier.showError(e.response.data);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
